// Real Formulas theme — shared interactions (reveal, header, mobile menu)
(function () {
  'use strict';

  // Header scroll state
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // Position the fixed header flush against the announcement bar. The bar
  // wraps to multiple lines on small screens, so its height is measured at
  // runtime rather than hardcoded. Breathing room for the logo lives inside
  // the header's own padding instead of a gap between the two bars.
  var announceEl = document.querySelector('.announce-bar');
  function syncHeaderOffset() {
    if (!header || !announceEl) return;
    header.style.top = announceEl.getBoundingClientRect().height + 'px';
  }
  if (announceEl) {
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    window.addEventListener('orientationchange', syncHeaderOffset);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderOffset);
    }
  }

  // Mobile menu — slide-in drawer
  (function initMobileMenu() {
    var toggle = document.querySelector('.mobile-toggle');
    var nav = document.querySelector('.site-header .nav');
    if (!toggle || !nav) return;

    var backdrop = document.querySelector('.mobile-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'mobile-backdrop';
      document.body.appendChild(backdrop);
    }

    function openMenu() {
      document.body.classList.add('mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      document.body.classList.remove('mobile-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    function toggleMenu() {
      document.body.classList.contains('mobile-menu-open') ? closeMenu() : openMenu();
    }

    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'primary-nav');
    nav.id = nav.id || 'primary-nav';

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleMenu();
    });
    backdrop.addEventListener('click', closeMenu);
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 768) closeMenu(); });
  })();

  // Reveal-on-scroll animations
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();